import {defineAsyncComponent} from "vue";
import {Model} from "@/services/api";

export default class Lafil013 extends Model {
    static relations = {
        persons: require("@/services/models/person").default,
        newspaper: require("@/services/models/newspaper").default,
        lafil014: require("@/services/models/lafil014").default,
    };

    toString() {
        return this.Evenement;
    }

    static route() {
        return 'events';
    }

    static primaryKey() {
        return 'CodeEvenement';
    }

    detail() {
        return {
            title: this,
            component: defineAsyncComponent(() => import('@/components/events/details.vue')),
            props: {value: this}
        };
    }
}
